export function validatePhone(phone) {
  const reg =  /^(?:(?:\+|00)86)?1\d{10}$/; // 以1开头的11位粗略判断
  return reg.test(phone)
}